/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum ORDER_STATUS {
	Created = 0,
	Canceled = 1,
	Filled = 2,
	Validated = 3,
	CancellationRequest = 4,
}
